// ============================================================
// Contact Page (Contact 2) — preserves Gravity Form id 3 on WP deploy
// ============================================================
import { Phone, Mail, MapPin, Clock } from "lucide-react";

export const CONTACT_PAGE = {
  hero: {
    eyebrow: "Contact Slingshot SEO",
    titlePre: "Let's talk about ",
    titleAccent: "your visibility.",
    sub: "Questions, audits, partnerships \u2014 a US-based strategist reads every message and responds within one business day.",
    bg: "https://images.unsplash.com/photo-1423666639041-f56000c27a9a?q=80&w=1920&auto=format&fit=crop",
  },
  info: {
    heading: "Prefer a direct line?",
    body: "Skip the form entirely \u2014 we're easy to reach, and there's a real person on the other end.",
    items: [
      { icon: Phone, label: "Call us", value: "845.567.7706", href: "tel:8455677706" },
      { icon: Mail, label: "Email us", value: "info@slingshotseo.com", href: "mailto:info@slingshotseo.com" },
      { icon: MapPin, label: "Headquarters", value: "New York, USA", href: null },
      { icon: Clock, label: "Response time", value: "Within 1 business day", href: null },
    ],
  },
  form: {
    heading: "Send us a message",
    note: "On the live site this is your existing Gravity Form (id 3) \u2014 untouched, with CAPTCHA and notifications exactly as configured.",
    fields: [
      { id: "name", label: "Name", type: "text", placeholder: "Your name" },
      { id: "email", label: "Email", type: "email", placeholder: "you@company.com" },
      { id: "linkedin", label: "LinkedIn", type: "text", placeholder: "linkedin.com/in/you (optional)" },
      { id: "subject", label: "Subject", type: "text", placeholder: "What's this about?" },
      { id: "message", label: "Your Message", type: "textarea", placeholder: "Tell us about your goals\u2026" },
    ],
  },
  cta: {
    heading: "Not ready to talk yet?",
    sub: "Start with the Free Visibility Audit \u2014 no call required. We'll send your rankings, AI citations and paid efficiency versus competitors in 2 business days.",
    primaryText: "Get My Free Visibility Audit",
  },
};

// ---------- Contact FAQ (also powers FAQPage schema) ----------
export const CONTACT_FAQ = {
  heading: "Before you reach out",
  items: [
    {
      q: "How quickly will I hear back?",
      a: "Within one business day \u2014 usually much faster. A real US-based strategist replies, not an autoresponder.",
    },
    {
      q: "Do you offer free consultations?",
      a: "Yes \u2014 the Free Visibility Audit includes a strategist walkthrough of your rankings, AI citations and fastest wins, with zero obligation.",
    },
    {
      q: "Do I have to commit to a long contract?",
      a: "No. Engagements are structured around milestones \u2014 we keep your business by performing, not by lock-in.",
    },
    {
      q: "Can you work alongside my in-house team or another agency?",
      a: "Absolutely. We frequently operate as the search arm for in-house marketing teams \u2014 and even for other agencies' clients.",
    },
  ],
};
